import _ from "lodash";

export const selectGoals = ({ goals: { goals } }) => {
  const sortedGoals = goals && _.orderBy(goals, ["accountUniqueId", "id"]);
  return sortedGoals;
};
